import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '16px',
    backgroundColor: '#FAFCFF',
    padding: '32px 40px',
    minWidth: '900px',
    width: '100%',
    height: 'auto',
    [theme.breakpoints.up('lg')]: {
      minWidth: '1200px',
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: '1500px',
    },
  },
  '& .MuiDialog-paperScrollPaper': {
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '10px',
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
    '&::-webkit-scrollbar-track': {
      margin: '60px 0',
    },
  },
}));

export const CloseButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  margin: '-20px',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '24px',
  fontWeight: '600',
  marginBottom: '32px',
  textTransform: 'capitalize',
  '& span': { color: theme.palette.secondary.main },
}));

export const EditButton = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  fontWeight: '600',
  backgroundColor: '#FAFCFF',
  width: 240,
  color: theme.palette.secondary.main,
  border: `2px solid ${theme.palette.secondary.main}`,
  display: 'flex',
  gap: '10px',
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '32px',
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '40%',
  border: `1.5px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
}));

export const FilledButton = styled(Button)(({ theme }) => ({
  width: '40%',
  backgroundColor: theme.palette.secondary.main,
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const CoordContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-around',
  padding: '8px',
  border: '1px solid #D7D8DB',
  borderRadius: '10px',
  margin: '16px 0 26px',
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
}));

export const BoldTypography = styled(Typography)(() => ({
  fontWeight: '600',
}));

export const MapButton = styled(Button)(({ theme }) => ({
  borderRadius: '10px',
  width: '100%',
  border: `2px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: '#FAFCFF',
  fontWeight: '600',
}));
